import type { SprintId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { FilterableIssue, MatcherCreator } from '../types.tsx';

export const sprintMatcherCreator: MatcherCreator<SprintId[], FilterableIssue> =
	(sprintFilter) =>
	({ sprintId }) =>
		sprintFilter.includes(sprintId || '');
